import { Component, ViewChild } from '@angular/core';
import { GuardService } from '../../services/guard.service';
import { FaqComponent } from '../faq/faq.component';
import { ModuleService } from '../../services/module.service';
import { ModuleDirective } from '../../directives/module.directive';
import { IS_PRODUCT_SAFETY_PROJECT, IS_TRS_PROJECT } from '../../../../current-project';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent extends ModuleDirective {
    IS_TRS_PROJECT = IS_TRS_PROJECT;
    IS_PRODUCT_SAFETY_PROJECT = IS_PRODUCT_SAFETY_PROJECT;

    @ViewChild(FaqComponent, { static: false }) faqComponent: FaqComponent;

    constructor(
        private guardService: GuardService,
        moduleService: ModuleService
    ) {
        super(moduleService);
    }

    get isAdmin(): boolean {
        return this.guardService.isAdmin;
    }

    openFaq() {
        this.faqComponent.toggle();
    }
}
